module.exports = __webpack_public_path__ + "img/circle_done.88dbe43b.svg";